<template>
    <div class="view">
        <h2>Rechercher une entreprise</h2>

        <b-form @submit="onSubmit" @reset="onReset" v-if="show">

            <b-col cols="10">

                <b-row>
                    <b-col>
                        <b-form-group id="input-group-libelle" label="Libellé" label-for="input-libelle">
                            <b-form-input
                                    id="input-libelle"
                                    v-model="entreprise.libelle"
                                    type="text"
                                    maxlength="200"
                                    :trim="true"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-card header="Siège">
                            <b-row>
                                <b-form-group id="input-group-siren"
                                              label="SIREN" label-for="input-siren">
                                    <b-form-input
                                            id="input-siren"
                                            v-model="entreprise.siren"
                                            type="text"
                                            maxlength="20"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-paysSiren"
                                              label="Pays Siège" label-for="input-paysSiren">
                                    <b-form-select
                                            id="input-paysSiren"
                                            v-model="entreprise.paysSiren"
                                            :options="pays">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">
                                                Sélectionner un pays
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-villeSiren" class="w-100"
                                              label="Ville Siège" label-for="input-villeSiren">
                                    <AutocompleteCustom
                                            id="input-villeSiren"
                                            :items="communes"
                                            v-model="entreprise.villeSiren"
                                            @search="searchCommunes">
                                    </AutocompleteCustom>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-villeSirenAutre" class="w-100"
                                              label="Ville Siège (étranger)" label-for="input-villeSirenAutre">
                                    <b-form-input
                                            id="input-villeSirenAutre"
                                            v-model="entreprise.villeSirenAutre"
                                            type="text"
                                            maxlength="100"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-adresseSiren" class="w-100"
                                              label="Adresse Siège" label-for="input-adresseSiren">
                                    <b-form-input
                                            id="input-adresseSiren"
                                            v-model="entreprise.adresseSiren"
                                            type="text"
                                            maxlength="200"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card header="Agence">
                            <b-row>
                                <b-form-group id="input-group-siret"
                                              label="SIRET" label-for="input-siret">
                                    <b-form-input
                                            id="input-siret"
                                            v-model="entreprise.siret"
                                            type="text"
                                            maxlength="30"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-paysSiret"
                                              label="Pays Agence" label-for="input-paysSiret">
                                    <b-form-select
                                            id="input-paysSiret"
                                            v-model="entreprise.paysSiret"
                                            :options="pays">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null">
                                                Sélectionner un pays
                                            </b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-villeSiret" class="w-100"
                                              label="Ville Agence" label-for="input-villeSiret">
                                    <AutocompleteCustom
                                            id="input-villeSiret"
                                            :items="communes"
                                            v-model="entreprise.villeSiret"
                                            @search="searchCommunes">
                                    </AutocompleteCustom>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-villeSiretAutre" class="w-100"
                                              label="Ville Agence (étranger)" label-for="input-villeSiretAutre">
                                    <b-form-input
                                            id="input-villeSiretAutre"
                                            v-model="entreprise.villeSiretAutre"
                                            type="text"
                                            maxlength="100"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                            <b-row>
                                <b-form-group id="input-group-adresseSiret" class="w-100"
                                              label="Adresse Agence" label-for="input-adresseSiret">
                                    <b-form-input
                                            id="input-adresseSiret"
                                            v-model="entreprise.adresseSiret"
                                            type="text"
                                            maxlength="200"
                                            :trim="true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-row>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col>
                        <b-form-group id="input-group-ess" label-for="input-ess"
                                      label="ESS (au sens de la Loi n°2014-856 du 31 juillet 2014 relative à l’Economie Sociale et Solidaire)">
                            <b-form-radio-group
                                    id="input-ess"
                                    v-model="entreprise.ess" :buttons="true"
                                    button-variant="outline-primary">
                                <b-form-radio :value="true">Oui</b-form-radio>
                                <b-form-radio :value="false">Non</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="pt-2">
                    <b-button type="submit" variant="primary">Soumettre</b-button>
                    <b-button type="reset" variant="danger">Réinitialiser</b-button>
                </div>

            </b-col>

        </b-form>

        <div v-if="formSubmitted" class="pt-5">

            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="entreprisesResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="entreprisesTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="editEntreprise(row.item.id)">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression d'entreprise"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="deleteEntreprise(row.item.id)">
                            <p>Confirmez-vous la suppression de cette entreprise ?</p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import EntrepriseStore from "../../stores/EntrepriseStore";
  import EntrepriseDto from "../../dtos/EntrepriseDto";
  import AlertStore from "../../stores/AlertStore";
  import InseeStore from "../../stores/InseeStore";
  import AutocompleteCustom from "../../components/AutocompleteCustom";

  export default {
    components: {AutocompleteCustom},
    data() {
      return {
        formSubmitted: false,
        entreprise: new EntrepriseDto(),
        entreprisesResult: null,
        show: true,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        communes: [],
        pays: [],
        fields: [
          {label: '', key: 'num', sortable: false},
          {label: 'Libellé', key: 'libelle', sortable: true},
          {label: 'SIREN', key: 'siren', sortable: true},
          {label: 'SIRET', key: 'siret', sortable: true},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false}
        ]
      }
    },
    computed: {
      entreprisesTable: function () {
        return this.entreprisesResult.content.map(entreprise => {
          return {
            id: entreprise.id,
            libelle: entreprise.libelle,
            siren: entreprise.siren,
            siret: entreprise.siret
          }
        });
      }
    },
    mounted() {
      this.initPagination();
      InseeStore.getAllPays().then(
          response => {
            this.pays = response.map(value => {
              return {text: value.libelle, value: value.id};
            });
          }
      );
    },
    methods: {
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'libelle', sortDirection: 'asc'}];
      },
      searchCommunes(codePostalLibelle) {
        if (codePostalLibelle && codePostalLibelle.length >= 2) {
          InseeStore.getCommunesByCodePostalLibelle(codePostalLibelle).then(
              communes => {
                this.communes = communes.map(value => {
                  return {text: `${value.libelle} (${value.codePostal.length === 4 ? '0' + value.codePostal : value.codePostal})`, value: value.id};
                });
              }
          );
        } else {
          this.communes = [];
        }
      },
      search() {
        EntrepriseStore.search(this.entreprise, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.entreprisesResult = result.data;
              this.formSubmitted = true;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      editEntreprise(id) {
        this.$router.push("/entreprises/" + id);
      },
      deleteEntreprise(id) {
        EntrepriseStore.delete(id).then(() => {
          this.search();
        });
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.initPagination();
        this.search();
      },
      onReset(evt) {
        evt.preventDefault();
        this.entreprise = new EntrepriseDto();
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true
        })
      }
    }
  }
</script>

